var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-gallery-container" },
    [
      _vm.buttons
        ? [
            _c("media-buttons", {
              attrs: {
                "container-class": "media-gallery-buttons",
                options: _vm.buttons_options,
                active: _vm.active,
                icons: true
              },
              on: { selected: _vm.mediaSelected }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-gallery-content" },
        [
          _vm.isActive("images")
            ? _c("images-gallery", {
                ref: "images_gallery",
                attrs: {
                  images: _vm.media.images,
                  "active-index": _vm.activeImage,
                  thumb: true
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("virtual_tour")
            ? _c("media-virtual-tour", {
                attrs: { src: _vm.media.virtual_tour }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("video")
            ? _c("media-video", { attrs: { src: _vm.media.video } })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("map")
            ? _c("detail-map", {
                attrs: {
                  latitude: _vm.media.map.latitude,
                  longitude: _vm.media.map.longitude,
                  exact: _vm.media.map.exact,
                  poi: _vm.poi
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("floor_plans")
            ? _c("images-gallery", {
                ref: "floor_plans_gallery",
                attrs: {
                  images: _vm.media.floor_plans,
                  "has-icons": true,
                  thumb: true
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }